import { LitElement, html, css } from 'lit';

import { LIT_CSS_VARIABLES } from '@Root/lib/lit-styles.js';
import { SHARED_ELEMENTS } from '../../styles';
import { icon } from '../../icons';
import {
  handleFileDownloadEvent,
  analyticsCtaDataObject,
} from '../../../../helpers/adobe-analytics.js';

class DownloadButton extends LitElement {
  static get styles() {
    return [
      LIT_CSS_VARIABLES,
      SHARED_ELEMENTS,
      css`
        a {
          cursor: pointer;
        }
      `,
    ];
  }

  static get properties() {
    return {
      downloadData: { type: Object },
    };
  }

  constructor() {
    super();
    this.downloadData = {};
  }

  render() {
    return html`
      <a
        href=${this.downloadData.link_url}
        target="_blank"
        download
        @click="${this._handleClick}"
      >
        ${icon('download-large')}
      </a>
    `;
  }

  _handleClick() {
    this.sendAnalyticsDownloadEvent();
  }

  get parsedDownloadData() {
    // EXPECTED DATA STRUCTURE FOR ANALYTICS
    // {
    //   file_format: 'JPG',
    //   file_name: 'Rose Carousel Image',
    //   link_url: image[1].full_resolution_src,
    //   link_type: 'IMAGE',
    //   placement: 'Rose Block',
    // }

    if (this.downloadData) return this.downloadData;

    this.downloadData = this.getAttribute('download-data')
      ? JSON.parse(this.getAttribute('download-data'))
      : null;

    return this.downloadData;
  }

  sendAnalyticsDownloadEvent() {
    handleFileDownloadEvent(analyticsCtaDataObject(this.downloadData));
  }

  get downloadUrl() {
    return this.getAttribute('download-url');
  }
}
customElements.define('download-button', DownloadButton);
